import React from "react"
import { Table as AntTable } from "antd"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { VisibilityProvider } from "src/components/visibility-provider"
import { usePermission } from "src/hooks"
import { useUpdateHeaderTitle } from "src/hooks/use-update-header-title"
import { EditDrawer } from "src/pages-lib/articles-categories/edit-drawer"
import {
  useGetCategories,
  useManageItems,
} from "src/pages-lib/articles-categories/model"
import { getColumns } from "src/pages-lib/articles-categories/table-columns"
import styled from "styled-components"

export default function ArticleCategories() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  // const [filterDrawerState, setFilterDrawerState] = React.useState(false)
  // const [sortableDrawerState, setSortableDrawerState] = React.useState(false)

  const { items: dataCategories, refetch: getItems, pagination } = useGetCategories()
  const { editData, onSaveEdit, onCreate, onDelete, onEditItem } = useManageItems(
    dataCategories,
    getItems,
    onSuccessEdit
  )

  const headerTitle = useUpdateHeaderTitle({
    items: dataCategories,
    defaultTitle: "0 Объектов",
    arrType: ["Категория", "Категории", "Категорий"],
  })

  const [tableParams] = React.useState({
    pagination: pagination ?? {
      current: 1,
      pageSize: 30,
    },
  })

  const columns = getColumns(hasPermission("article-categories.edit") ? onEditItem : null, hasPermission("article-categories.delete") ? onDelete : null)

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={hasPermission("article-categories.create") ? () => setCreateDrawerState(!createDrawerState) : undefined}
            // onFilter={() => setFilterDrawerState(!filterDrawerState)}
            // onSort={() => setSortableDrawerState(!sortableDrawerState)}
            titles={{ onCreate: "Добавить Категорию" }}
          />
        }
      />
      <StyledTable
        dataSource={dataCategories}
        columns={columns}
        pagination={tableParams.pagination}
      />

      {hasPermission("article-categories.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            onSave={onCreate}
            onClose={() => setCreateDrawerState(!createDrawerState)}
            title={"Создание категории"}
          />
        </VisibilityProvider>
      )}

      {hasPermission("article-categories.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            onSave={onSaveEdit}
            onClose={() => setEditDrawerState(!editDrawerState)}
            initialValues={editData}
            title={"Редактирование категории"}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
